export const BUILDING_3D_SETTINGS_KEY = 'dlv.maps.building3d.settings.v1';
export const MIN_BUILDINGS_VISIBLE_ZOOM = 16;

export const DEFAULT_BUILDING_3D_SETTINGS = {
  sideColor: '#d9d0c9',
  startZoom: MIN_BUILDINGS_VISIBLE_ZOOM
};

const clampStartZoom = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return DEFAULT_BUILDING_3D_SETTINGS.startZoom;
  return Math.min(Math.max(num, MIN_BUILDINGS_VISIBLE_ZOOM), 24);
};

const isHexColor = (value) => /^#([0-9A-Fa-f]{6})$/.test(value);

export const normalizeBuilding3DSettings = (settings) => {
  const sideColorCandidate = typeof settings?.sideColor === 'string' ? settings.sideColor.trim() : '';
  const sideColor = isHexColor(sideColorCandidate) ? sideColorCandidate : DEFAULT_BUILDING_3D_SETTINGS.sideColor;
  return {
    sideColor,
    startZoom: clampStartZoom(settings?.startZoom)
  };
};

export const loadBuilding3DSettings = () => {
  try {
    const raw = window.localStorage.getItem(BUILDING_3D_SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_BUILDING_3D_SETTINGS };
    const parsed = JSON.parse(raw);
    return normalizeBuilding3DSettings(parsed);
  } catch (error) {
    return { ...DEFAULT_BUILDING_3D_SETTINGS };
  }
};

export const saveBuilding3DSettings = (settings) => {
  try {
    const normalized = normalizeBuilding3DSettings(settings);
    window.localStorage.setItem(BUILDING_3D_SETTINGS_KEY, JSON.stringify(normalized));
    return normalized;
  } catch (error) {
    return normalizeBuilding3DSettings(settings);
  }
};
